<template>
  <div class="form-check form-check-inline">
    <input
      type="checkbox"
      :id="'cb1-' + row.id"
      class="ml-2"
      v-model="row.selected"
      value="1"
      :disabled="row.descanso"
    />
    <input
      type="checkbox"
      :id="'cb2-' + row.id"
      class="ml-2"
      v-model="row.descanso"
      @change="activarEmit"
      value="2"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "SelectRow",
  data() {
    return {
      selected: false,
      activar: this.row.descanso,
    };
  },
  props: ["row"],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift", "selectAll"]),
    ...mapGetters(["modTipshiftReport", ["getAllSelected"]]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
    ]),

    activarEmit() {
      if (this.row.descanso) {
        this.row.selected = !this.row.descanso;
      }
    },
  },
  watch: {},
  updated: function () {},
};
</script>

<style lang="scss" scoped>
input[id*="cb1"],
#cb2 {
  //display: flex;
  position: relative;
  z-index: 1;

  // display: inline !important;
}

input[id*="cb1"]:checked,
#cb2:checked {
  content: "\02713";
  background: #5d5fef;
  border-radius: 2px;
  color: #fff;
  margin-bottom: inherit;
}

input[id*="cb1"]:focus,
#cb2:focus {
  box-shadow: 0px 0px 4px 2px #ccc;
}

input[id*="cb1"]:hover,
#cb2:hover {
  box-shadow: 0px 0px 5px #5d5fef;
}

input[id*="cb1"] + label,
#cb2 + label {
  margin-left: 0px;
}

input[type="checkbox"] + label {
  margin-left: 0px !important;
  //display: none;
}
</style>